module.exports = __webpack_public_path__ + "static/media/banana.537d2ab9.png";